import AxiosInstance from 'src/shared/services/axios/interceptor';

export interface ImagePost {
  file: File;
}

// Listpost från GET /Image — speglar ImageListItemResponse i backend.
export interface ImageListItem {
  imageGuid: string;
  fileName: string;
  fileSize: number;
  contentType: string;
  location: string;
}

const controller = 'Image';

const createFormData = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
};

export const createImage = (data: File) => {
  const endpoint = `${controller}`;
  const formData = createFormData(data);
  return AxiosInstance.post(endpoint, formData);
};

// Listar inloggad användares uppladdade bilder, nyaste först (sortering på image_id DESC).
// Paginering via skip/take — default fönster 50 bilder.
export const listMyImages = (skip = 0, take = 50) => {
  const endpoint = `${controller}?skip=${skip}&take=${take}`;
  return AxiosInstance.get<ImageListItem[]>(endpoint);
};

// TODO: Typa
export const getImageByGuid = (guid: string) => {
  const endpoint = `${controller}/data/${guid}`;
  return AxiosInstance.get<any>(endpoint);
};
